import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Icon",
  width: "36",
  height: "36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M26.4 24.7a1.428 1.428 0 0 1-1.429 1.586H11.03A1.429 1.429 0 0 1 9.6 24.7l1.257-11.271h14.286L26.4 24.7Z",
  stroke: "currentColor",
  "stroke-width": "1.71",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.429 13.429v-2.143a3.572 3.572 0 0 1 7.142 0v2.143",
  stroke: "currentColor",
  "stroke-width": "1.71",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }